import React, { useState } from "react";
import { useLanguage } from "../shared/LanguageContext";
import { websiteCopy } from "../shared/websiteCopy";

const API_BASE = process.env.REACT_APP_API_BASE || "";

export default function PurchaseComplete() {
  const { language } = useLanguage();
  const copy = websiteCopy[language].purchaseComplete;
  const [state, setState] = useState("ready");
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");

  const sessionId = new URLSearchParams(window.location.search).get(
    "session_id"
  );

  async function claimAccess(event) {
    event.preventDefault();

    if (!sessionId || !email.trim()) {
      setError(copy.incompleteError);
      return;
    }

    setState("verifying");
    setError("");

    try {
      const response = await fetch(`${API_BASE}/api/fulfillment/claim`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
        body: JSON.stringify({
          checkout_session_id: sessionId,
          email: email.trim(),
        }),
      });

      if (!response.ok) {
        throw new Error(copy.fulfillmentError);
      }

      setState("authorized");
      window.location.replace("/mirror-of-the-mind/book/read");
    } catch {
      setState("error");
      setError(
        copy.verificationError
      );
    }
  }

  if (!sessionId) {
    return (
      <main className="purchase-complete">
        <h1>{copy.title}</h1>
        <p>{copy.incomplete}</p>
      </main>
    );
  }

  if (state === "authorized") {
    return (
      <main className="purchase-complete">
        <h1>{copy.confirmed}</h1>
        <p>{copy.paymentVerified}</p>
        <p>{copy.accessAuthorized}</p>
      </main>
    );
  }

  return (
    <main className="purchase-complete">
      <h1>{copy.title}</h1>
      <p>{copy.instruction}</p>
      <p>{copy.accessEmailSent}</p>
      <p>{copy.accessEmailSpam}</p>
      <p>{copy.accessEmailSender}</p>
      <p>{copy.accessEmailRecovery}</p>

      <form onSubmit={claimAccess}>
        <label htmlFor="purchase-email">{copy.email}</label>
        <input
          id="purchase-email"
          type="email"
          value={email}
          onChange={(event) => setEmail(event.target.value)}
          autoComplete="email"
          required
        />

        <button type="submit" disabled={state === "verifying"}>
          {state === "verifying" ? copy.verifying : copy.verify}
        </button>
      </form>

      {state === "error" && <p role="alert">{error}</p>}
    </main>
  );
}
